import { render, staticRenderFns } from "./defaultLoginPage.vue?vue&type=template&id=58634550&"
import script from "./defaultLoginPage.vue?vue&type=script&lang=js&"
export * from "./defaultLoginPage.vue?vue&type=script&lang=js&"
import style0 from "./defaultLoginPage.vue?vue&type=style&index=0&id=58634550&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports